import React from 'react';

const Toolbar = ({ contextMenuRef, handleDelete, id }) => {

    return (
        <div
            ref={contextMenuRef}
            className="mt-1.5 w-full overflow-hidden rounded-xl border border-gray-200 bg-white py-1 shadow-lg"
        >
            <button
                type="button"
                className="flex w-full items-center gap-2 px-4 py-2 text-left text-sm font-medium text-gray-600
                    transition-colors hover:bg-gray-50 hover:text-gray-900"
            >
                Duplicate
            </button>

            <div className="my-1 h-px bg-gray-100" />

            <button
                type="button"
                onClick={() => handleDelete(id)}
                className="flex w-full items-center gap-2 px-4 py-2 text-left text-sm font-medium text-red-600
                    transition-colors hover:bg-red-50
                    dark:text-red-400 dark:hover:bg-red-950/30"
            >
                Delete
            </button>
        </div>
    );
};

export default Toolbar;
